import {
  FETCH_SELECTED_CONTENT_ERROR,
  FETCH_SELECTED_CONTENT_PENDING,
  FETCH_SELECTED_CONTENT_SUCCESS,
} from '../actions/selected-content/SelectedContentActionTypes';

export interface SelectedContentState {
  pending: boolean;
  data: any;
  error: string | null;
}

const INITIAL_STATE: SelectedContentState = {
  pending: false,
  data: null,
  error: null,
};

const selectedContentReducer = (state = INITIAL_STATE, action) => {
  const payload: SelectedContentState = action.payload;
  switch (action.type) {
    case FETCH_SELECTED_CONTENT_PENDING:
      return {...state, pending: true};

    case FETCH_SELECTED_CONTENT_SUCCESS:
      return {...state, pending: false, data: payload};

    case FETCH_SELECTED_CONTENT_ERROR:
      return {...state, pending: false, error: payload};

    default:
      return state;
  }
};

export default selectedContentReducer;
